// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".appeal-tag[data-v-14cb90b2]{display:inline-block;padding:0 .4rem;border:1px solid #ced4da;border-radius:3px;color:#6c757d;font-size:11px;font-weight:400;line-height:1.6;vertical-align:middle;white-space:nowrap}.appeal-tag--other[data-v-14cb90b2]{border-color:#f4a95b;background:#fff3e3;color:#c25a00;font-weight:700;letter-spacing:.02em}", ""]);
// Exports
module.exports = exports;
